import React, { useEffect, useState } from 'react'
import WarehouseList from '../client-wm-list'
import { Button, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { wmsService } from '../../utils/services/wmsProvider'

const WMSList = ({
  clientId,
  onEditWms,
  disabled,
  onClickAddWms,
  handleDeleteClickWms,
  onViewWmsData,
  isOpened
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const fetchProviderDetails = async (id, signal) => {
    if (id) {
      setLoading(true)
      try {
        const wmsResponse = await wmsService.fetch(id, '', '', { signal })
        setData(wmsResponse.data)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.error('Fetch failed:', error)
      }
    }
  }

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal
    if (isOpened) {
      fetchProviderDetails(clientId, signal)
    }
    return () => {
      controller.abort()
    }
  }, [isOpened])
  return (
    <div>
      <WarehouseList
        addButton={
          <Button
            disabled={disabled}
            onClick={onClickAddWms}
            style={{
              // backgroundColor: disabled ? "#F0F0F0" : "#FD7E14",
              padding: 0,
              marginRight: 8,
              marginLeft: 25,
              // paddingRight: 10,
              minHeight: 30,
              // marginBottom: 1,
              border: disabled ? '1px solid #BDBDBD' : '1px solid #FD7E14'
            }}
            aria-label="oms"
            variant="outlined"
            startIcon={<AddIcon sx={{ color: disabled ? '#BDBDBD' : '#FD7E14' }} />}
          >
            <Typography
              fontSize="13px"
              color={disabled ? '#BDBDBD' : '#FD7E14'}
              fontWeight={500}
              fontFamily={'poppins'}
            >
              WMS
            </Typography>
          </Button>
        }
        handleDeleteClick={handleDeleteClickWms}
        onViewWmsData={onViewWmsData}
        onEditData={onEditWms}
        data={data}
        refreshData={() => fetchProviderDetails(clientId)}
      />
    </div>
  )
}

export default WMSList
